// @flow

import * as React from "react";

import Icon from "../atoms/Icon";

type PropsType = {
    children: React.Node,
    className?: string,
};

const ShowMore = (props: PropsType) => {
    const contentRef = React.useRef(null);
    const innerContentRef = React.useRef(null);
    const classList = ["show-more"];
    const [isExpandable, setIsExpandable] = React.useState(false);
    const [expanded, setExpanded] = React.useState(false);
    const [innerContentHeight, setInnerContentHeight] = React.useState("auto");
    const heightDiffTolerance = props.tolerance || 0;

    React.useEffect(() => {
        if (innerContentRef.current) {
            // decide whether to enable show more expanding
            if (
                props.collapsedHeight + heightDiffTolerance <=
                innerContentRef.current.clientHeight
            ) {
                setIsExpandable(true);
            } else {
                setIsExpandable(false);
            }
        }
    }, [props.children, props.collapsedHeight, heightDiffTolerance]);

    React.useEffect(() => {
        if (isExpandable) {
            setInnerContentHeight(expanded ? "auto" : props.collapsedHeight);
        }
    }, [isExpandable, expanded, props.collapsedHeight]);

    if (props.className) {
        classList.push(props.className);
    }

    if (expanded) {
        classList.push("is-expanded");
    }

    return (
        <div className={classList.join(" ")}>
            <div
                ref={contentRef}
                className="show-more__content"
                style={{ height: innerContentHeight }}
            >
                <div ref={innerContentRef}>{props.children}</div>
            </div>

            {isExpandable ? (
                <button
                    type="button"
                    className="show-more__btn"
                    onClick={() => setExpanded(!expanded)}
                >
                    Show {expanded ? "less" : "more"}
                    <Icon name="chevron-down" />
                </button>
            ) : (
                false
            )}
        </div>
    );
};

export default ShowMore;
